import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import styles from './UserActionButton.module.scss';
import cn from 'classnames';
import { useConversation, getIconByActionType, handleActions, UserActionDef, UserActionType } from '@chewy/chat-library-common';
import ChatButton from './ChatButton';
import { useState } from 'react';

export interface UserActionButtonProps {
    /** The message to display in the button */
    message?: string;
    /** Click handler for the button */
    onClick?: (data: UserActionDef | undefined) => void;
    /** Widget data from the registry (contains message and action) */
    data?: UserActionDef[];
    icon?: React.ReactNode;
    className?: string;
    /** When true, the button is disabled */
    disabled?: boolean;
}

export default function UserActionButton({
    message = 'Get help from our care team',
    onClick,
    data,
    icon,
    className,
    disabled = false,
}: UserActionButtonProps) {
    const { submitQuestion, phase } = useConversation();
    const [hasBeenClicked, setHasBeenClicked] = useState(false);
    const widget = data?.[0];
    const defaultAction = widget?.defaultAction;
    const isShowSeparator = widget?.showSeparator === true;
    const clickHandler = onClick ?? widget?.onClick;
    const isConnectWithAgentAction = [UserActionType.CONNECT_TO_AGENT, UserActionType.CONTACT_CARE_TEAM].includes(defaultAction?.payload?.action);
    const isWithAgent = ['agent', 'transferred'].includes(phase ?? '');
    const isDisabled = disabled || (isConnectWithAgentAction && (isWithAgent || hasBeenClicked));

    // Use message from data prop if available, otherwise fall back to message prop or default
    const displayMessage = defaultAction?.text ?? message;
    const effectiveIcon = icon ?? getIconByActionType(defaultAction?.payload?.action);


    const handleClick = () => {
        if (isDisabled) {
            return;
        }

      setHasBeenClicked(true);

      if (submitQuestion && defaultAction?.userMessage) {
          submitQuestion(defaultAction.userMessage);
      } else if (defaultAction) {
          handleActions(defaultAction, widget);
      }
      if (clickHandler) {
          clickHandler(widget);
      }
    };

    return (
        <>
            {isShowSeparator && (
                <div className={styles.agentOrDivider}>
                    <span className={styles.agentOrLine} aria-hidden="true" />
                    <span className={styles.agentOrText}>or</span>
                    <span className={styles.agentOrLine} aria-hidden="true" />
                </div>
            )}
            <ChatButton
              className={cn(styles.userActionButton, className)}
              onClick={handleClick}
              icon={effectiveIcon}
              buttonText={displayMessage}
              disabled={isDisabled}
            />
        </>
    );
}
